import { render, staticRenderFns } from "./AppointmentRescheduleThankYou.vue?vue&type=template&id=0b923ffb&"
import script from "./AppointmentRescheduleThankYou.vue?vue&type=script&lang=js&"
export * from "./AppointmentRescheduleThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports